import * as ExcelJS from 'exceljs';
import { ExcelImportData } from '../types/article';

export interface ExcelParseResult {
  data: ExcelImportData[];
  errors: string[];
}

// **Excel-Spaltenzuordnung - Erweitert für vollständige Artikeldaten**
const COLUMN_MAPPING = {
  // **GRUNDDATEN**
  '_Value': '_Value', // Artikelnummer
  '#BCItemDescription': 'name', // Name (primär) -> name in DB
  'BCItemDescription': 'name', // Name (ohne # Zeichen) -> name in DB
  'bcItemDescription': 'name', // Name (lowercase) -> name in DB
  'WEDLBezeichnung1_DE': 'wedlDesignation1', // WEDL Bezeichnung 1 -> wedlDesignation1 in DB
  'WEDLBezeichnung1': 'WEDLBezeichnung1', // WEDL Bezeichnung 1 (preserve original field name)
  'WEDLBezeichnung2_DE': 'wedlDesignation2', // WEDL Bezeichnung 2 -> wedlDesignation2 in DB
  'WEDLBezeichnung2': 'WEDLBezeichnung2', // WEDL Bezeichnung 2 (preserve original field name)
  'description': 'description', // Beschreibung -> description in DB
  'BrandName': 'brand', // Marke -> brand in DB
  'brand': 'brand', // Marke (alternative) -> brand in DB
  
  // **IDENTIFIKATION & CODES**
  'MarkantbaseUnitGtin': 'gtin', // GTIN -> gtin in DB
  'gtin': 'gtin', // GTIN (alternative) -> gtin in DB
  '#ItemNumber': 'itemNumber', // Item Number -> itemNumber in DB
  'itemNumber': 'itemNumber', // Item Number (alternative) -> itemNumber in DB
  'MarkantsupplierAssignedIdentNumber': 'supplierAssignedId', // Externe Artikelnummer -> supplierAssignedId in DB
  'externalArticleNumber': 'supplierAssignedId', // Externe Artikelnummer (alternative)
  'supplierAssignedId': 'supplierAssignedId', // Lieferanten ID
  'MarkantIntrastatNumber': 'intrastatNumber', // Intrastat -> intrastatNumber in DB
  'intrastatNumber': 'intrastatNumber', // Intrastat (alternative)
  '#RelWEDLHauptlieferantKreditorNr': 'creditorNumber', // Kreditor-Nr. -> creditorNumber in DB
  'creditorNumber': 'creditorNumber', // Kreditor-Nr. (alternative)
  
  // **INHALT & EINHEITEN - KORRIGIERT**
  'WEDLInhalt': 'wedlContent', // Inhalt -> wedlContent in DB (Number)
  'content': 'wedlContent', // Inhalt (alternative) -> wedlContent in DB
  'WEDLInhaltEinheit_DE': 'wedlContentUnit', // Inhaltseinheit -> wedlContentUnit in DB
  'WEDLInhaltEinheit': 'WEDLInhaltEinheit', // Inhaltseinheit (preserve original field name)
  'contentUnit': 'wedlContentUnit', // Inhaltseinheit (alternative) -> wedlContentUnit in DB
  'WEDLEinheit_DE': 'wedlUnit', // Werbeeinheit -> wedlUnit in DB
  'WEDLEinheit': 'WEDLEinheit', // Werbeeinheit (preserve original field name)
  'unit': 'wedlUnit', // Werbeeinheit (alternative) -> wedlUnit in DB
  'WEDLStkGewichtsartikel': 'pieceWeightArticle', // Stückgewichtsartikel (Excel-Name) -> pieceWeightArticle in DB
  'pieceWeightArticle': 'pieceWeightArticle', // Stückgewichtsartikel -> pieceWeightArticle in DB
  
  // **NETTO-INHALT**
  'MarkantnetContent': 'netContent', // Netto-Inhalt -> netContent in DB
  'netContent': 'netContent', // Netto-Inhalt (alternative)
  'MarkantnetContentUom_DE': 'netContentUom', // Netto-Inhaltseinheit -> netContentUom in DB
  'netContentUom': 'netContentUom', // Netto-Inhaltseinheit (alternative)
  'MarkantdrainedWeight': 'drainedWeight', // Abtropfgewicht -> drainedWeight in DB
  'drainedWeight': 'drainedWeight', // Abtropfgewicht (alternative)
  'MarkantdrainedWeightUom_DE': 'drainedWeightUom', // Abtropfgewicht Einheit -> drainedWeightUom in DB
  'drainedWeightUom': 'drainedWeightUom', // Abtropfgewicht Einheit (alternative)
  
  // **LINIE**
  'WEDLLinie_DE': 'wedlLine', // WEDL Linie -> wedlLine in DB
  'line': 'wedlLine', // Linie (alternative) -> wedlLine in DB
  'wedlLine': 'wedlLine', // Linie (direkt)
  
  // **LIEFERANTEN-INFO**
  'WEDLSupplierCodeHauptlieferant': 'mainSupplierCode', // Hauptlieferant Code -> mainSupplierCode in DB
  'WEDLSupplierCode': 'WEDLSupplierCode', // Supplier Code -> WEDLSupplierCode (preserve original field name)
  'mainSupplierCode': 'mainSupplierCode', // Hauptlieferant Code (alternative)
  '#RELWEDLHauptlieferantGLN': 'mainSupplierGLN', // Hauptlieferant GLN -> mainSupplierGLN in DB
  'mainSupplierGLN': 'mainSupplierGLN', // Hauptlieferant GLN (alternative)
  '#RELWEDLLieferantang': 'supplierContact', // Lieferant Kontakt -> supplierContact in DB
  'supplierContact': 'supplierContact', // Lieferant Kontakt (alternative)
  
  // **HERSTELLER-INFO**
  'MarkantmanufacturerName': 'manufacturerName', // Herstellername -> manufacturerName in DB
  'manufacturerName': 'manufacturerName', // Herstellername (alternative)
  'MarkantmanufacturerGLN': 'manufacturerGLN', // Hersteller GLN -> manufacturerGLN in DB
  'manufacturerGLN': 'manufacturerGLN', // Hersteller GLN (alternative)
  'MarkantcontactName': 'contactName', // Inverkehrbringen Name -> contactName in DB
  'contactName': 'contactName', // Inverkehrbringen Name (alternative)
  'MarkantcontactAddress': 'contactAddress', // Inverkehrbringen Adresse -> contactAddress in DB
  'contactAddress': 'contactAddress', // Inverkehrbringen Adresse (alternative)
  
  // **GEFAHRGUT**
  'MarkantdangerousGoodsRegulation_DE': 'dangerousGoods', // Gefahrgut (mit _DE) -> dangerousGoods in DB
  'MarkantdangerousGoodsRegulation': 'dangerousGoods', // Gefahrgut -> dangerousGoods in DB
  'dangerousGoods': 'dangerousGoods', // Gefahrgut (alternative)
  
  // **LAUFZEITEN & HALTBARKEIT**
  'LMIVMarkantMinTermIncomming': 'minTermIncoming', // Min. Lauftage Eingang -> minTermIncoming in DB
  'minTermIncoming': 'minTermIncoming', // Min. Lauftage Eingang (alternative)
  '#LMIVMarkantMinTermOutcoming': 'minTermOutgoing', // Min. Lauftage Ausgang -> minTermOutgoing in DB
  'minTermOutgoing': 'minTermOutgoing', // Min. Lauftage Ausgang (alternative)
  'GHPA00HBK': 'shelfLifeDays', // Haltbarkeit in Tagen -> shelfLifeDays in DB
  'shelfLifeDays': 'shelfLifeDays', // Haltbarkeit in Tagen (alternative)
  
  // **TEMPERATUR**
  'LMIVMarkantStockTempMin': 'stockTempMin', // Min. Temperatur -> stockTempMin in DB
  'stockTempMin': 'stockTempMin', // Min. Temperatur (alternative)
  'LMIVMarkantStockTempMax': 'stockTempMax', // Max. Temperatur -> stockTempMax in DB
  'stockTempMax': 'stockTempMax', // Max. Temperatur (alternative)
  
  // **KATEGORIEN & CODES**
  'WEDLABTABTKZWGRKZ': 'departmentCode', // Abteilungscode -> departmentCode in DB
  'departmentCode': 'departmentCode', // Abteilungscode (alternative)
  'WEDLLagerzone_DE': 'storageZone', // Lagerzone -> storageZone in DB
  'storageZone': 'storageZone', // Lagerzone (alternative)
  
  // **HERKUNFT**
  'MarkantCountryOfOrigin': 'countryOfOrigin', // Herkunftsland -> countryOfOrigin in DB
  'countryOfOrigin': 'countryOfOrigin', // Herkunftsland (alternative)
  'WEDLHerkunftslandtrue': 'originCountryTrue', // Herkunftsland (true) -> originCountryTrue in DB
  'originCountryTrue': 'originCountryTrue', // Herkunftsland (true, alternative)
  
  // **MEHRWEG/EINWEG**
  'MarkantonewayReusableCode_DE': 'reusableCode', // Mehrweg/Einweg -> reusableCode in DB
  'reusableCode': 'reusableCode', // Mehrweg/Einweg (alternative)
  
  // **ECR CODES**
  '#RELWEDLECRECRSGECRSUGECRWGREbene1': 'ecrLevel1', // ECR Level 1 -> ecrLevel1 in DB
  'ecrLevel1': 'ecrLevel1', // ECR Level 1 (alternative)
  '#RELWEDLECRECRSGECRSUGECRWGREbene2': 'ecrLevel2', // ECR Level 2 -> ecrLevel2 in DB
  'ecrLevel2': 'ecrLevel2', // ECR Level 2 (alternative)
  'WEDLECRECRSGECRSUGECRWGR': 'ecrCode', // ECR Code (vollständig) -> ecrCode in DB
  'ecrCode': 'ecrCode', // ECR Code (direkt) -> ecrCode in DB
  'ekCode': 'ekCode', // EK Code -> ekCode in DB
  
  // **LABELS**
  'WEDLLabels_DE': 'labels', // Labels -> labels in DB (Array)
  'labels': 'labels', // Labels (alternative)
  
  // **ALKOHOL**
  'LMIVAlcoholContent': 'alcoholContent', // Alkoholgehalt -> alcoholContent in DB
  'alcoholContent': 'alcoholContent', // Alkoholgehalt (alternative)
  
  // **FISCH-SPEZIFISCHE FELDER**
  'Fangzone': 'fangzone', // Fangzone -> fangzone in DB
  'fangzone': 'fangzone', // Fangzone (alternative)
  'Fangmethode': 'fangmethode', // Fangmethode -> fangmethode in DB  
  'fangmethode': 'fangmethode', // Fangmethode (alternative)
  'WEDLWissenschaftlicherArtname': 'scientificName', // Lateinischer Name -> scientificName in DB
  'scientificName': 'scientificName', // Lateinischer Name (alternative)
  'WEDLProduktionsmethode': 'productionMethod', // Produktionsmethode -> productionMethod in DB
  'productionMethod': 'productionMethod', // Produktionsmethode (alternative)
  'WEDLAuftauhinweis': 'thawingInstructions', // Auftauhinweis -> thawingInstructions in DB
  'thawingInstructions': 'thawingInstructions', // Auftauhinweis (alternative)
  
  // **GRUNDPREIS**
  'WEDLGrundpreisinhalt': 'basePriceContent', // Grundpreisinhalt (Excel-Name) -> basePriceContent in DB
  'WEDLGrundeinheit_DE': 'baseUnit', // Grundeinheit (Excel-Name) -> baseUnit in DB
  'WEDLBasisVerglEinheitencode_DE': 'baseComparisonUnitCode', // Basis Vergleichs-Einheitencode (Excel-Name) -> baseComparisonUnitCode in DB
  'basePriceContent': 'basePriceContent', // Grundpreisinhalt -> basePriceContent in DB
  'baseUnit': 'baseUnit', // Grundeinheit -> baseUnit in DB
  'baseComparisonUnitCode': 'baseComparisonUnitCode', // Basis Vergleichs-Einheitencode -> baseComparisonUnitCode in DB
  
  // **VERKAUFSPREIS**
  'salesPrice': 'salesPrice', // VK-Preis -> salesPrice in DB
  'verkaufspreis': 'salesPrice' // VK-Preis (deutsch) -> salesPrice in DB
};

// **Excel-Datei parsen**
export const parseExcelFile = async (file: File): Promise<ExcelParseResult> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    
    reader.onload = async (e) => {
      try {
        const buffer = e.target?.result as ArrayBuffer;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);
        
        // Erste Arbeitsblatt verwenden
        const worksheet = workbook.worksheets[0];
        
        if (!worksheet) {
          resolve({
            data: [],
            errors: ['Keine Arbeitsblätter in der Excel-Datei gefunden']
          });
          return;
        }
        
        // Daten aus Worksheet extrahieren
        const jsonData: any[][] = [];
        worksheet.eachRow((row, rowNumber) => {
          const rowData: any[] = [];
          row.eachCell((cell, colNumber) => {
            rowData[colNumber - 1] = cell.value;
          });
          jsonData.push(rowData);
        });
        
        if (jsonData.length < 2) {
          resolve({
            data: [],
            errors: ['Excel-Datei muss mindestens eine Header- und eine Datenzeile enthalten']
          });
          return;
        }
        
        // Header-Zeile extrahieren und normalisieren
        const rawHeaders = jsonData[0] as string[];
        const headers = rawHeaders.map(header => {
          if (header === null || header === undefined) return '';
          return String(header).trim().replace(/^["']|["']$/g, ''); // Entferne führende/abschließende Anführungszeichen und Leerzeichen
        });
        const dataRows = jsonData.slice(1);
        
        // Validiere erforderliche Spalten (nur _Value ist wirklich erforderlich)
        const requiredColumns = ['_Value'];
        
        // Hinweis: BCItemDescription und alle anderen Spalten sind OPTIONAL und können leer gelassen werden
        const missingColumns = requiredColumns.filter(col => !headers.includes(col));
        
        if (missingColumns.length > 0) {
          resolve({
            data: [],
            errors: [`Erforderliche Spalten fehlen: ${missingColumns.join(', ')}`]
          });
          return;
        }
        
        // Daten verarbeiten
        const parsedData: ExcelImportData[] = [];
        const errors: string[] = [];
        
        dataRows.forEach((row, index) => {
          const rowNumber = index + 2; // +2 wegen Header und 0-basiertem Index
          
          // Leere Zeilen überspringen
          if (row.every(cell => !cell || cell.toString().trim() === '')) {
            return;
          }
          
          try {
            const rowData: any = {};
            
            // Jede Spalte verarbeiten
            headers.forEach((header, colIndex) => {
              const cellValue = row[colIndex];
              
              if (header in COLUMN_MAPPING) {
                const mappedKey = COLUMN_MAPPING[header as keyof typeof COLUMN_MAPPING];
                
                // Datentyp-Konvertierung
                if (header === 'WEDLInhalt' || 
                    header === 'LMIVAlcoholContent' || 
                    header === 'content' || 
                    header === 'alcoholContent' ||
                    header === 'MarkantnetContent' ||
                    header === 'netContent' ||
                    header === '#ProductCompletePct' ||
                    header === 'productCompletePct' ||
                    header === 'LMIVMarkantMinTermIncomming' ||
                    header === 'minTermIncoming' ||
                    header === '#LMIVMarkantMinTermOutcoming' ||
                    header === 'minTermOutgoing') {
                  // Numerische Werte - Österreichische Dezimaltrennzeichen berücksichtigen
                  if (cellValue && cellValue !== '') {
                    const normalizedValue = cellValue.toString().replace(',', '.');
                    const numValue = parseFloat(normalizedValue);
                    if (!isNaN(numValue)) {
                      rowData[mappedKey] = numValue;
                    }
                  }
                } else if (header === 'WEDLGoldenRecord' || 
                          header === 'goldenRecord' ||
                          header === 'GHPFreigabe' ||
                          header === 'ghpApproval' ||
                          header === '#ApprovedERP' ||
                          header === 'approvedERP' ||
                          header === '#ApprovedPrint' ||
                          header === 'approvedPrint' ||
                          header === 'pieceWeightArticle') {
                  // Boolean-Werte
                  if (cellValue && cellValue !== '') {
                    const boolValue = cellValue.toString().toLowerCase();
                    rowData[mappedKey] = boolValue === 'true' || boolValue === '1' || boolValue === 'ja' || boolValue === 'yes';
                  }
                } else {
                  // String-Werte
                  if (cellValue && cellValue !== '') {
                    rowData[mappedKey] = cellValue.toString().trim();
                  }
                }
              }
            });
            
            // Erforderliche Felder validieren - nur _Value ist wirklich erforderlich
            if (!rowData._Value) {
              errors.push(`Zeile ${rowNumber}: Artikelnummer (_Value) ist erforderlich`);
              return;
            }
            
            // Alle anderen Felder sind optional - keine Name-Validierung mehr
            
            parsedData.push(rowData as ExcelImportData);
            
          } catch (error) {
            errors.push(`Zeile ${rowNumber}: Fehler beim Verarbeiten der Daten - ${error}`);
          }
        });
        
        resolve({
          data: parsedData,
          errors
        });
        
      } catch (error) {
        resolve({
          data: [],
          errors: [`Fehler beim Lesen der Excel-Datei: ${error}`]
        });
      }
    };
    
    reader.onerror = () => {
      resolve({
        data: [],
        errors: ['Fehler beim Lesen der Datei']
      });
    };
    
    reader.readAsArrayBuffer(file);
  });
};

// **CSV-Datei parsen**
export const parseCSVFile = async (file: File): Promise<ExcelParseResult> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const csvText = e.target?.result as string;
        const lines = csvText.split('\n').filter(line => line.trim() !== '');
        
        if (lines.length < 2) {
          resolve({
            data: [],
            errors: ['CSV-Datei muss mindestens eine Header- und eine Datenzeile enthalten']
          });
          return;
        }
        
        // Header-Zeile extrahieren
        const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
        const dataLines = lines.slice(1);
        
        // Validiere erforderliche Spalten (nur Mindestanforderungen)
        const requiredColumns = ['_Value'];
        // Name kann verschiedene Varianten haben (mit oder ohne # Zeichen)
        const hasName = headers.includes('#BCItemDescription') || 
                       headers.includes('BCItemDescription') || 
                       headers.includes('WEDLBezeichnung1_DE') || 
                       headers.includes('bcItemDescription');
        
        if (!hasName) {
          resolve({
            data: [],
            errors: ['Erforderliche Spalte für Name fehlt: #BCItemDescription, BCItemDescription, WEDLBezeichnung1_DE oder bcItemDescription']
          });
          return;
        }
        
        // Hinweis: Alle anderen Spalten sind OPTIONAL und können leer gelassen werden
        const missingColumns = requiredColumns.filter(col => !headers.includes(col));
        
        if (missingColumns.length > 0) {
          resolve({
            data: [],
            errors: [`Erforderliche Spalten fehlen: ${missingColumns.join(', ')}`]
          });
          return;
        }
        
        // Daten verarbeiten
        const parsedData: ExcelImportData[] = [];
        const errors: string[] = [];
        
        dataLines.forEach((line, index) => {
          const rowNumber = index + 2;
          
          try {
            const values = line.split(',').map(v => v.trim().replace(/"/g, ''));
            const rowData: any = {};
            
            headers.forEach((header, colIndex) => {
              const cellValue = values[colIndex];
              
              if (header in COLUMN_MAPPING) {
                const mappedKey = COLUMN_MAPPING[header as keyof typeof COLUMN_MAPPING];
                
                // Datentyp-Konvertierung
                if (header === 'WEDLInhalt' || 
                    header === 'LMIVAlcoholContent' || 
                    header === 'content' || 
                    header === 'alcoholContent' ||
                    header === 'MarkantnetContent' ||
                    header === 'netContent' ||
                    header === '#ProductCompletePct' ||
                    header === 'productCompletePct' ||
                    header === 'LMIVMarkantMinTermIncomming' ||
                    header === 'minTermIncoming' ||
                    header === '#LMIVMarkantMinTermOutcoming' ||
                    header === 'minTermOutgoing') {
                  // Numerische Werte - Österreichische Dezimaltrennzeichen berücksichtigen
                  if (cellValue && cellValue !== '') {
                    const normalizedValue = cellValue.toString().replace(',', '.');
                    const numValue = parseFloat(normalizedValue);
                    if (!isNaN(numValue)) {
                      rowData[mappedKey] = numValue;
                    }
                  }
                } else if (header === 'WEDLGoldenRecord' || 
                          header === 'goldenRecord' ||
                          header === 'GHPFreigabe' ||
                          header === 'ghpApproval' ||
                          header === '#ApprovedERP' ||
                          header === 'approvedERP' ||
                          header === '#ApprovedPrint' ||
                          header === 'approvedPrint' ||
                          header === 'pieceWeightArticle') {
                  // Boolean-Werte
                  if (cellValue && cellValue !== '') {
                    const boolValue = cellValue.toString().toLowerCase();
                    rowData[mappedKey] = boolValue === 'true' || boolValue === '1' || boolValue === 'ja' || boolValue === 'yes';
                  }
                } else {
                  if (cellValue && cellValue !== '') {
                    rowData[mappedKey] = cellValue;
                  }
                }
              }
            });
            
            // Erforderliche Felder validieren - nur _Value ist wirklich erforderlich  
            if (!rowData._Value) {
              errors.push(`Zeile ${rowNumber}: Artikelnummer (_Value) ist erforderlich`);
              return;
            }
            
            // Alle anderen Felder sind optional - keine Name-Validierung mehr
            
            parsedData.push(rowData as ExcelImportData);
            
          } catch (error) {
            errors.push(`Zeile ${rowNumber}: Fehler beim Verarbeiten der Daten - ${error}`);
          }
        });
        
        resolve({
          data: parsedData,
          errors
        });
        
      } catch (error) {
        resolve({
          data: [],
          errors: [`Fehler beim Lesen der CSV-Datei: ${error}`]
        });
      }
    };
    
    reader.onerror = () => {
      resolve({
        data: [],
        errors: ['Fehler beim Lesen der Datei']
      });
    };
    
    reader.readAsText(file, 'UTF-8');
  });
};

// **Hauptfunktion zum Parsen verschiedener Dateiformate**
export const parseImportFile = async (file: File): Promise<ExcelParseResult> => {
  const fileExtension = file.name.split('.').pop()?.toLowerCase();
  
  switch (fileExtension) {
    case 'xlsx':
    case 'xls':
      return parseExcelFile(file);
    
    case 'csv':
      return parseCSVFile(file);
    
    default:
      return {
        data: [],
        errors: ['Nicht unterstütztes Dateiformat. Verwenden Sie Excel (.xlsx, .xls) oder CSV-Dateien.']
      };
  }
};

export default {
  parseExcelFile,
  parseCSVFile,
  parseImportFile
};
